<template>
  <div>
    <b-row>
      <!--WEB SERVICE-->
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="name" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.config_name')" :placeholderValue="$t('common.routing.config_name')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="brokersDomain" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.brokers_domain')" :placeholderValue="$t('common.routing.brokers_domain')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="brokersPort" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.brokers_port')" :placeholderValue="$t('common.routing.brokers_port')">
        </form-write-group-label-input>
      </b-col>
      <b-col sm="6" class="form-group">
        <form-write-group-label-input v-model="topic" isMandatory :disabled="readonly"
          :inputLabel="$t('common.routing.topic')" :placeholderValue="$t('common.routing.topic')">
        </form-write-group-label-input>
      </b-col>
    </b-row>
    <form-accordion title="Token credentials" :isTitleUpperCase="false" v-if="login && password">
      <b-row>
        <b-col cols="6" class="fake-hr-right px-0">
          <b-col class="form-group">
            <form-write-group-label-input v-model="loginStorage" :disabled="true" :maxLength="512" inputType="select"
              :inputLabel="$t('common.routing.loginStorage')">
              <select class="form-control" v-model="loginStorage" :disabled="true">
                <option value="">{{ $t('common.routing.volume_select') }}</option>
                <option value="PEM">{{ 'PEM' }}</option>
                <option value="FILE">{{ 'Volume' }}</option>
                <option value="Vault">{{ 'Vault' }}</option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="loginFile" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.loginFile')" :placeholderValue="$t('common.routing.loginFile')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label>Variable</label>
                <b-form-radio-group v-model="loginFileType" :disabled="true">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">ENV</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="loginYAML" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.loginYAML')" :placeholderValue="$t('common.routing.loginYAML')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label>Variable</label>
                <b-form-radio-group v-model="loginYAMLType" :disabled="true">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">ENV</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>

        </b-col>
        <b-col cols="6" class="px-0">
          <b-col class="form-group">
            <form-write-group-label-input v-model="passwordStorage" :disabled="true" :maxLength="512" inputType="select"
              :inputLabel="$t('common.routing.passwordStorage')">
              <select class="form-control" v-model="loginStorage" :disabled="true">
                <option value="">{{ $t('common.routing.volume_select') }}...</option>
                <option value="PEM">{{ 'PEM' }}</option>
                <option value="FILE">{{ 'Volume' }}</option>
                <option value="Vault">{{ 'Vault' }}</option>
              </select>
            </form-write-group-label-input>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="passwordFile" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.passwordFile')" :placeholderValue="$t('common.routing.passwordFile')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label>Variable</label>
                <b-form-radio-group v-model="passwordFileType" :disabled="true">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">ENV</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
          <b-col class="form-group">
            <b-row>
              <b-col cols="8">
                <form-write-group-label-input v-model="passwordYAML" :disabled="true" :maxLength="512"
                  :inputLabel="$t('common.routing.passwordYAML')" :placeholderValue="$t('common.routing.passwordYAML')">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="4">
                <label>Variable</label>
                <b-form-radio-group v-model="passwordYAMLType" :disabled="true">
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="ENV">ENV</b-form-radio>
                  <b-form-radio name="variableP12PwdInsideFile-radio" value="OTHER">{{ $t('common.other') }}</b-form-radio>
                </b-form-radio-group>
              </b-col>
            </b-row>
          </b-col>
        </b-col>
      </b-row>
    </form-accordion>
  </div>
</template>
<script>

import CertificateFormGlobal from '@/pages/routing/global/CertificateFormGlobal.vue'
import FormAccordion from '@/components/common/FormAccordion.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import LevelControlForm from '@/pages/routing/global/LevelControlForm.vue'
import PrivateKeysFormGlobal from '@/pages/routing/global/PrivateKeysFormGlobal.vue'

export default {
  name: 'WebServiceConfigurationForm',
  components: {
    'certificate-form-global': CertificateFormGlobal,
    'form-accordion': FormAccordion,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'level-control-form' : LevelControlForm,
    'private-keys-form-global': PrivateKeysFormGlobal
  },
  props: {
    mode: {
      type: String,
      default: "create"
    },
    placementWebService: {
      type: Number,
      default: -1
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }

  },
  computed:{
    inputValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
    name: {
      get () {
        return this.inputValue.name
      },
      set (val) {
        this.inputValue = {
          name: val,
          brokers: this.inputValue.brokers,
          topic: this.inputValue.topic,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    brokersDomain: {
      get () {
        let split = this.inputValue.brokers ? this.inputValue.brokers.split(':') : []
        return split.length > 0 ? split[0] : ''
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          brokers: val + ':' + this.brokersPort,
          topic: this.inputValue.topic,
          sslActive: this.inputValue.sslActive,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    brokersPort: {
      get () {
        let split = this.inputValue.brokers ? this.inputValue.brokers.split(':') : []
        return split.length > 1 ? split[1] : ''
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          brokers: this.brokersDomain + ':' + val,
          topic: this.inputValue.topic,
          sslActive: this.inputValue.sslActive,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    topic: {
      get () {
        return this.inputValue.topic
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          brokers: this.inputValue.brokers,
          topic: val,
          sslActive: this.inputValue.sslActive,
          login: this.inputValue.login,
          password: this.inputValue.password
        }
      }
    },
    login: {
      get () {
        return this.inputValue.login
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          brokers: this.inputValue.brokers,
          topic: this.inputValue.topic,
          login: val,
          password: this.inputValue.password
        }
      }
    },
    loginStorage: {
      get () {
        let storageMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    loginFile: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },
    loginFileType: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    loginYAML: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    loginYAMLType: {
      get () {
        let envMatch = this.inputValue.login.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    password: {
      get () {
        return this.inputValue.password
      },
      set (val) {
        this.inputValue = {
          name: this.inputValue.name,
          brokers: this.inputValue.brokers,
          topic: this.inputValue.topic,
          login: this.inputValue.login,
          password: val
        }
      }
    },
    passwordStorage: {
      get () {
        let storageMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return storageMatch && storageMatch.length > 1 ? storageMatch[1] : ''
      }
    },
    passwordFile: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 3 ? envMatch[3] : ''
      }
    },

    passwordFileType: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 2 ? envMatch[2] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    },
    passwordYAML: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        return envMatch && envMatch.length > 5 ? envMatch[5] : ''
      }
    },
    passwordYAMLType: {
      get () {
        let envMatch = this.inputValue.password.match(/^(\w+):\(\((\w+):(\w+)\),\((\w+):(\w+)\)\)$/)
        let res = envMatch && envMatch.length > 4 ? envMatch[4] : ''
        return res === 'ENV' ? res : 'OTHER'
      }
    }
  },
  data () {
    return {
    }
  },
  created () {
  },
  mounted () {
  },
  methods: {
  }
}

</script>
